import { cva, type VariantProps } from 'class-variance-authority';
import type { PropertyFilters } from '~/core/entities/property/filters';

export { default as OrdenationSelect } from './OrdenationSelect.vue';

export interface OrdenationDropdownProps {
	labelVariant?: OrdenationSelectLabelVariant['variant'];
}

export interface OrdenationDropdownOption {
	label: string;
	value?:
		| 'images_count_asc'
		| 'images_count_desc'
		| 'asking_price_asc'
		| 'asking_price_desc'
		| 'pilar_exclusivities'
		| 'highlights'
		| 'most_recent'
		| 'older'
		| 'default_ordenation';
	sortBy: PropertyFilters['sortBy'];
	orderBy: PropertyFilters['orderBy'];
}

export const ordenationSelectLabelVariant = cva('', {
	variants: {
		variant: {
			default: 'hidden md:inline',
			hidden: 'hidden'
		}
	},
	defaultVariants: {
		variant: 'default'
	}
});

export type OrdenationSelectLabelVariant = VariantProps<
	typeof ordenationSelectLabelVariant
>;
